import styled from 'styled-components';

import { Button } from 'components/uikit/Button/Button';
import { Popup } from 'components/uikit/Popup/Popup';

export const StyledPopup = styled(Popup)`
  max-width: 510px;
  min-width: 510px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled.h2`
  margin-bottom: 8px;

  font: var(--font-heading-large-24);
`;

export const Description = styled.p`
  display: flex;
  justify-content: center;
  margin-bottom: 0px;
`;

export const DescriptionText = styled.p`
  margin-bottom: 24px;

  font: var(--font-regular-15);
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  gap: 12px;
`;

export const AgreeButton = styled(Button).attrs({ size: 'm' })`
  width: ${(p) => (p.onlyAgree ? '150px' : '100%')};
  margin: 0 auto;
`;

export const CancelButton = styled(Button).attrs({ size: 'm', theme: '3' })`
  width: 100%;
`;
